module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "112313123"
    },
    attrs: {
      "showClose": false,
      "isBgOverlay": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal__opus",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Data fra KMD OPUS for " + _vm._s(_vm.user.v_user_name))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__header__right"
  }, [_c('div', {
    staticClass: "icon__bg-circle no-print",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }) : [_c('h3', [_vm._v("\n          For perioden " + _vm._s(_vm.titleOfPeriod) + "\n        ")]), _vm._v(" "), (_vm.oneTimePayments.length === 0) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen data for perioden")]) : _vm._e(), _vm._v(" "), (_vm.oneTimePayments.length > 0) ? _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.oneTimePayments[0]), function(value, key) {
    return _c('th', {
      key: key
    }, [_vm._v("\n              " + _vm._s(key.replace('_', ' ')) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.oneTimePayments), function(payment) {
    return _c('tr', {
      key: payment.id
    }, _vm._l((payment), function(value, key) {
      return _c('td', {
        key: key
      }, [_vm._v("\n              " + _vm._s(value || '-') + "\n            ")])
    }), 0)
  }), 0)]) : _vm._e()]], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9df5b962!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySubsPerfUserOpusModal.vue
// module id = 2070
// module chunks = 1